module.exports = __webpack_public_path__ + "media/suburb_sunrise.61acd7c2.ogg";